import { render, staticRenderFns } from "./PaginaIniziale.vue?vue&type=template&id=32085d27&scoped=true&"
import script from "./PaginaIniziale.vue?vue&type=script&lang=js&"
export * from "./PaginaIniziale.vue?vue&type=script&lang=js&"
import style0 from "./PaginaIniziale.vue?vue&type=style&index=0&id=32085d27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32085d27",
  null
  
)

export default component.exports